import { render, staticRenderFns } from "./CustomStaticLabel.vue?vue&type=template&id=4be86975&lang=pug&"
import script from "./CustomStaticLabel.vue?vue&type=script&lang=js&"
export * from "./CustomStaticLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports